export default __webpack_public_path__ + "static/atlassian-ai-dark-8037f3babc063d46c6a4f0258dbc642e.png";